/* Momentier - consolidated theme enhancements (deferred). */
(function () {
  'use strict';

  var cfg = window.MomentierConfig || {};

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  // ---- A. Product trust badges ---------------------------------------------
  function initTrustBadges() {
    var btnsContainer = document.querySelector('.productView-buttons');
    if (!btnsContainer) return;
    if (document.querySelector('.momentier-trust-badges')) return;

    var badges = document.createElement('div');
    badges.className = 'momentier-trust-badges';
    badges.innerHTML =
      '<div class="trust-badge-item">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>' +
        '<span>Free Shipping over ₹999</span>' +
      '</div>' +
      '<div class="trust-badge-item">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>' +
        '<span>COD Available</span>' +
      '</div>' +
      '<div class="trust-badge-item">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
        '<span>Secure Payments</span>' +
      '</div>';

    btnsContainer.insertAdjacentElement('afterend', badges);
  }

  // ---- B. Scent pyramid ----------------------------------------------------
  function initScentPyramid() {
    var scentTab = document.getElementById('tab-scent-notes');
    if (!scentTab) return;
    var toggleContent = scentTab.querySelector('.toggle-content');
    if (!toggleContent) return;
    var html = toggleContent.innerHTML;
    var tierMap = {
      'Top Notes': { cls: 'pyramid-top', desc: 'The opening impression', icon: '<svg class="tier-icon" viewBox="0 0 28 28" fill="none"><path d="M14 4l2 4h-4l2-4z" fill="currentColor" opacity="0.3"/><path d="M8 14c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" stroke-width="1.2" fill="none"/><path d="M6 14c0 4.4 3.6 8 8 8s8-3.6 8-8" stroke="currentColor" stroke-width="1.2" fill="none"/><circle cx="14" cy="9" r="1.5" fill="currentColor" opacity="0.5"/><line x1="14" y1="4" x2="14" y2="7" stroke="currentColor" stroke-width="1" opacity="0.4"/><line x1="10" y1="6" x2="12" y2="8" stroke="currentColor" stroke-width="1" opacity="0.4"/><line x1="18" y1="6" x2="16" y2="8" stroke="currentColor" stroke-width="1" opacity="0.4"/></svg>' },
      'Middle Notes': { cls: 'pyramid-heart', desc: 'The character', icon: '<svg class="tier-icon" viewBox="0 0 28 28" fill="none"><path d="M14 24c-5-4-9-7.5-9-11.5C5 8.9 7.9 6 11.5 6c1.5 0 2.5.7 2.5.7S15 6 16.5 6C20.1 6 23 8.9 23 12.5c0 4-4 7.5-9 11.5z" stroke="currentColor" stroke-width="1.2" fill="none"/><path d="M14 20c-3-2.5-5.5-4.8-5.5-7.5C8.5 10.6 10 9 12 9c.8 0 1.4.3 2 .8.6-.5 1.2-.8 2-.8 2 0 3.5 1.6 3.5 3.5 0 2.7-2.5 5-5.5 7.5z" fill="currentColor" opacity="0.15"/></svg>' },
      'Heart Notes': { cls: 'pyramid-heart', desc: 'The character', icon: '<svg class="tier-icon" viewBox="0 0 28 28" fill="none"><path d="M14 24c-5-4-9-7.5-9-11.5C5 8.9 7.9 6 11.5 6c1.5 0 2.5.7 2.5.7S15 6 16.5 6C20.1 6 23 8.9 23 12.5c0 4-4 7.5-9 11.5z" stroke="currentColor" stroke-width="1.2" fill="none"/><path d="M14 20c-3-2.5-5.5-4.8-5.5-7.5C8.5 10.6 10 9 12 9c.8 0 1.4.3 2 .8.6-.5 1.2-.8 2-.8 2 0 3.5 1.6 3.5 3.5 0 2.7-2.5 5-5.5 7.5z" fill="currentColor" opacity="0.15"/></svg>' },
      'Base Notes': { cls: 'pyramid-base', desc: 'The lasting signature', icon: '<svg class="tier-icon" viewBox="0 0 28 28" fill="none"><rect x="6" y="18" width="16" height="4" rx="1" stroke="currentColor" stroke-width="1.2" fill="currentColor" opacity="0.1"/><rect x="8" y="13" width="12" height="5" rx="1" stroke="currentColor" stroke-width="1.2" fill="currentColor" opacity="0.08"/><rect x="10" y="8" width="8" height="5" rx="1" stroke="currentColor" stroke-width="1.2" fill="currentColor" opacity="0.05"/></svg>' }
    };
    var tierLabels = { 'Top Notes': 'TOP', 'Middle Notes': 'HEART', 'Heart Notes': 'HEART', 'Base Notes': 'BASE' };
    var tiers = [];
    var regex = /<strong>\s*(Top Notes|Middle Notes|Heart Notes|Base Notes)\s*:?\s*<\/strong>\s*:?\s*([^<]+)/gi;
    var match;
    while ((match = regex.exec(html)) !== null) {
      var tierName = match[1];
      var notes = match[2].trim().split(/\s*,\s*/);
      var info = tierMap[tierName] || tierMap['Middle Notes'];
      var label = tierLabels[tierName] || tierName.toUpperCase();
      tiers.push({ cls: info.cls, label: label, desc: info.desc, notes: notes, icon: info.icon });
    }
    if (tiers.length === 0) return;
    var pyramidHTML = '<div class="scent-pyramid"><div class="pyramid-visual-track">';
    tiers.forEach(function (tier, i) {
      pyramidHTML += '<div class="pyramid-tier ' + tier.cls + '" data-tier="' + i + '">';
      pyramidHTML += '<div class="tier-header"><div class="tier-icon-wrap">' + tier.icon + '</div>';
      pyramidHTML += '<div class="tier-title-group"><span class="tier-label">' + tier.label + '</span><span class="tier-desc">' + tier.desc + '</span></div></div>';
      pyramidHTML += '<div class="tier-notes">';
      tier.notes.forEach(function (note) {
        pyramidHTML += '<span class="note-pill">' + note.trim() + '</span>';
      });
      pyramidHTML += '</div></div>';
    });
    pyramidHTML += '</div></div>';
    toggleContent.innerHTML = pyramidHTML;
  }

  // ---- C. Footer enhancement ----------------------------------------------
  function initFooterEnhancement() {
    var footer = document.querySelector('footer.footer');
    if (!footer) return;
    if (footer.parentNode.querySelector('.momentier-footer-callout')) return;

    var calloutBar = document.createElement('div');
    calloutBar.className = 'momentier-footer-callout';
    calloutBar.innerHTML =
      '<div class="footer-callout-inner">' +
        '<div class="callout-item">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 18H3a2 2 0 01-2-2V8a2 2 0 012-2h3.19M15 6h2.81A2 2 0 0120 7.19L21 8v8a2 2 0 01-2 2h-2"/><circle cx="7" cy="18" r="2"/><path d="M9 18h6"/><circle cx="17" cy="18" r="2"/><path d="M14 6V4a2 2 0 00-4 0v2"/></svg>' +
          '<div><span class="callout-title">Free Shipping</span><span class="callout-sub">On orders over ₹999</span></div>' +
        '</div>' +
        '<div class="callout-item">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
          '<div><span class="callout-title">Secure Payments</span><span class="callout-sub">UPI, Cards & COD</span></div>' +
        '</div>' +
        '<div class="callout-item">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>' +
          '<div><span class="callout-title">Extrait de Parfum</span><span class="callout-sub">33%+ oil concentration</span></div>' +
        '</div>' +
        '<div class="callout-item">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>' +
          '<div><span class="callout-title">Made in India</span><span class="callout-sub">Crafted with pride</span></div>' +
        '</div>' +
      '</div>';
    footer.parentNode.insertBefore(calloutBar, footer);

    var socialItems = footer.querySelectorAll('.list-social__item a, .list-social a');
    socialItems.forEach(function (a) { a.style.color = '#FBF7F2'; });
    var socialSvgs = footer.querySelectorAll('.list-social__item svg, .list-social svg');
    socialSvgs.forEach(function (svg) {
      svg.style.color = '#FBF7F2';
      svg.style.fill = 'none';
      svg.style.stroke = '#FBF7F2';
    });

    var bottomBar = footer.querySelector('.footer__content-bottom');
    if (bottomBar) {
      var container = bottomBar.querySelector('.container') || bottomBar;
      var enhancedBottom = document.createElement('div');
      enhancedBottom.className = 'momentier-footer-bottom';
      enhancedBottom.innerHTML =
        '<div class="footer-bottom-row">' +
          '<div class="footer-bottom-left">' +
            '<span class="footer-tagline">Extrait Perfumes Named After Feelings</span>' +
            '<span class="footer-copyright">© 2026 Momentier. All rights reserved.</span>' +
          '</div>' +
          '<div class="footer-bottom-right">' +
            '<div class="footer-payment-icons">' +
              '<span class="payment-label">We Accept</span>' +
              '<div class="payment-icons-row">' +
                '<span class="payment-icon" title="Visa">VISA</span>' +
                '<span class="payment-icon" title="Mastercard">MC</span>' +
                '<span class="payment-icon" title="UPI">UPI</span>' +
                '<span class="payment-icon" title="Cash on Delivery">COD</span>' +
                '<span class="payment-icon" title="RuPay">RuPay</span>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      var existingCopyright = container.querySelector('.copyright__content, .copyright');
      if (existingCopyright) existingCopyright.style.display = 'none';
      container.appendChild(enhancedBottom);
    }
  }

  // ---- D. Product page redesign -------------------------------------------
  function initProductRedesign() {
    var container = document.querySelector('.productView-product');
    if (!container) return;
    var kids = Array.from(container.children);

    var titleBlock = null, descBlock = null, priceBlock = null, sizeBlock = null;
    var qtyBlock = null, buyBlock = null, pyramidBlock = null, tabsBlock = null;
    var hideList = [];

    kids.forEach(function (kid) {
      if (kid.querySelector('.productView-title')) titleBlock = kid;
      else if (kid.tagName === 'P' && kid.textContent.trim().length > 20 && !descBlock) descBlock = kid;
      else if (kid.querySelector('.productView-price, .price') && !priceBlock) priceBlock = kid;
      else if (kid.querySelector('.productView-options, .swatch') && !sizeBlock) sizeBlock = kid;
      else if (kid.querySelector('.productView-quantity') && !kid.querySelector('.productView-buttons') && !qtyBlock) qtyBlock = kid;
      else if (kid.querySelector('.productView-buttons')) buyBlock = kid;
      else if (kid.classList.contains('momentier-inline-pyramid')) pyramidBlock = kid;
      else if (kid.tagName === 'PRODUCT-TAB') tabsBlock = kid;
      if (kid.textContent && kid.textContent.indexOf('SKU') > -1 && kid.querySelector('.productView-info-name')) {
        hideList.push(kid);
      }
      if (kid.querySelector('.productView-securityImage')) {
        var secList = kid.querySelector('.productView-securityImage ul');
        if (secList && secList.children.length === 0) hideList.push(kid);
      }
    });

    hideList.forEach(function (el) { el.classList.add('momentier-hidden'); });

    if (buyBlock && pyramidBlock && buyBlock.parentNode === container) {
      container.insertBefore(buyBlock, pyramidBlock);
    }

    if (titleBlock) {
      var titleParent = titleBlock.closest('.productView-product > *') || titleBlock.parentElement;
      var descTab = document.getElementById('tab-scent-description') || document.getElementById('tab-scent-description-mobile');
      var taglineText = '';
      if (descTab) {
        var italicEl = descTab.querySelector('em, i');
        if (italicEl) taglineText = italicEl.textContent.trim();
      }
      if (taglineText && taglineText.length > 5 && taglineText.length < 100) {
        if (!container.querySelector('.momentier-tagline')) {
          var tagline = document.createElement('div');
          tagline.className = 'momentier-tagline';
          tagline.textContent = taglineText;
          titleParent.appendChild(tagline);
        }
      }
    }

    if (!pyramidBlock) {
      var scentNotesTab = document.getElementById('tab-scent-notes') || document.getElementById('tab-scent-notes-mobile');
      var pyramid = scentNotesTab ? scentNotesTab.querySelector('.scent-pyramid') : null;
      if (pyramid && buyBlock) {
        var pyramidWrapper = document.createElement('div');
        pyramidWrapper.className = 'momentier-inline-pyramid productView-moreItem';
        var pyramidLabel = document.createElement('div');
        pyramidLabel.className = 'pyramid-section-label';
        pyramidLabel.textContent = 'FRAGRANCE PROFILE';
        pyramidWrapper.appendChild(pyramidLabel);
        pyramidWrapper.appendChild(pyramid.cloneNode(true));
        buyBlock.parentNode.insertBefore(pyramidWrapper, buyBlock.nextSibling);
      }
      var tabToggles = container.querySelectorAll('.toggle-title, .toggleLink');
      tabToggles.forEach(function (toggle) {
        if (toggle.textContent.trim() === 'Scent Notes') {
          toggle.style.display = 'none';
          var next = toggle.nextElementSibling;
          if (next) next.style.display = 'none';
        }
      });
    }

    var allToggles = container.querySelectorAll('.toggleLink');
    allToggles.forEach(function (t) {
      if (t.textContent.trim() === 'Scent Description' && !t.classList.contains('is-open')) t.click();
    });

    if (priceBlock && !container.querySelector('.momentier-detail-strip')) {
      var detailStrip = document.createElement('div');
      detailStrip.className = 'momentier-detail-strip';
      detailStrip.innerHTML =
        '<div class="detail-item"><svg class="detail-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg><span class="detail-value">Extrait</span><span class="detail-label">Purest Grade</span></div>' +
        '<div class="detail-divider"></div>' +
        '<div class="detail-item"><svg class="detail-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22c4-4 8-7.5 8-12a8 8 0 10-16 0c0 4.5 4 8 8 12z"/><circle cx="12" cy="10" r="3"/></svg><span class="detail-value">Natural Oils</span><span class="detail-label">Rich Formulation</span></div>' +
        '<div class="detail-divider"></div>' +
        '<div class="detail-item"><svg class="detail-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg><span class="detail-value">All-Day</span><span class="detail-label">Lasting Power</span></div>' +
        '<div class="detail-divider"></div>' +
        '<div class="detail-item"><svg class="detail-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg><span class="detail-value">33%+ Oils</span><span class="detail-label">Perfume Concentration</span></div>';
      priceBlock.parentNode.insertBefore(detailStrip, priceBlock.nextSibling);
    }
  }

  // ---- E. Extrait section scroll animation --------------------------------
  function initExtraitAnim() {
    var sec = document.querySelector('.m-extrait-section');
    if (!sec) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio >= 0.25 && !sec.classList.contains('m-anim-active')) {
            sec.classList.add('m-anim-active');
            io.disconnect();
          }
        });
      }, { threshold: [0, 0.25, 0.5] });
      io.observe(sec);
      return;
    }

    function check() {
      if (sec.classList.contains('m-anim-active')) return;
      var rect = sec.getBoundingClientRect();
      var wh = window.innerHeight || document.documentElement.clientHeight;
      var visibleTop = Math.max(0, rect.top);
      var visibleBottom = Math.min(wh, rect.bottom);
      var visibleH = visibleBottom - visibleTop;
      if (visibleH > rect.height * 0.25) {
        sec.classList.add('m-anim-active');
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    }
    function onScroll() { requestAnimationFrame(check); }
    check();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  // ---- F. Discount banner (uses Liquid-rendered config) -------------------
  function initDiscountBanner() {
    var d = cfg.discount || {};
    if (!d.enabled || !document.body.classList.contains('template-product')) return;
    if (!d.text || !d.code) return;
    if (document.querySelector('.m-discount-banner')) return;
    var target = document.querySelector('.productView-group');
    if (!target) return;

    var banner = document.createElement('div');
    banner.className = 'm-discount-banner';
    banner.innerHTML =
      '<svg class="m-discount-svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
      '<span class="m-discount-text">' + d.text + ' &nbsp;|&nbsp; Use code: <strong>' + d.code + '</strong></span>';
    target.parentNode.insertBefore(banner, target.nextSibling);
  }

  // ---- G. Collection variant price fix -------------------------------------
  function initCollectionPriceFix() {
    if (!window.location.pathname.includes('/collections/')) return;

    function getActiveSizeFilter() {
      var chips = document.querySelectorAll('a.active-facets__button,.active-facets__button');
      for (var i = 0; i < chips.length; i++) {
        var t = chips[i].textContent.replace(/[×✕✗x]/gi, '').trim();
        if (/^\d+\s*ml$/i.test(t)) return t.trim();
      }
      return null;
    }

    function formatPrice(p) {
      var a = parseFloat(p);
      return 'Rs. ' + a.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function updateCards() {
      var activeSize = getActiveSizeFilter();
      if (!activeSize) return;
      var m = window.location.pathname.match(/\/collections\/([^\/]+)/);
      var h = m ? m[1] : 'all';
      fetch('/collections/' + h + '/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var map = {};
          data.products.forEach(function (p) { map[String(p.id)] = p; });
          document.querySelectorAll('li.product').forEach(function (card) {
            var form = card.querySelector('form[data-product-id]');
            if (!form) return;
            var product = map[form.getAttribute('data-product-id')];
            if (!product) return;
            var variant = null;
            for (var k = 0; k < product.variants.length; k++) {
              if (product.variants[k].title.toLowerCase().trim() === activeSize.toLowerCase().trim()) {
                variant = product.variants[k]; break;
              }
            }
            if (!variant) return;
            var lbl = card.querySelector('.card-variant-size');
            if (lbl) lbl.textContent = variant.title;
            var priceEl = card.querySelector('.price-item--regular');
            if (priceEl) priceEl.textContent = formatPrice(variant.price);
            var cpEl = card.querySelector('.price__compare .price-item--regular');
            if (cpEl) {
              var cp = variant.compare_at_price;
              if (cp && parseFloat(cp) > parseFloat(variant.price)) {
                cpEl.textContent = formatPrice(cp);
                var cpc = cpEl.closest('.price__compare');
                if (cpc) cpc.removeAttribute('hidden');
              } else {
                cpEl.textContent = '';
                var cpc2 = cpEl.closest('.price__compare');
                if (cpc2) cpc2.setAttribute('hidden', '');
              }
            }
            card.querySelectorAll('.swatch-element').forEach(function (sw) {
              var match = (sw.getAttribute('data-value') || '').toLowerCase().trim() === activeSize.toLowerCase().trim();
              sw.classList.toggle('active', match);
              sw.classList.toggle('selected', match);
              var inp = sw.querySelector('input.single-option');
              if (inp) inp.checked = match;
            });
          });
        });
    }

    function scheduleUpdate(attempt) {
      setTimeout(function () {
        if (getActiveSizeFilter()) {
          updateCards();
        } else if (attempt < 10) {
          scheduleUpdate(attempt + 1);
        }
      }, attempt === 0 ? 0 : 500);
    }

    scheduleUpdate(0);

    ['ajaxFiltered', 'collectionUpdated', 'filterUpdated', 'ella:collection:updated'].forEach(function (e) {
      document.addEventListener(e, updateCards);
    });

    var grid = document.getElementById('main-collection-product-grid') || document.querySelector('.productListing');
    if (grid && window.MutationObserver) {
      new MutationObserver(function (ms) {
        if (ms.some(function (mu) { return mu.addedNodes.length > 0; })) updateCards();
      }).observe(grid, { childList: true, subtree: false });
    }
  }

  // ---- Bootstrap -----------------------------------------------------------
  onReady(function () {
    initTrustBadges();
    initScentPyramid();
    initFooterEnhancement();
    initProductRedesign();
    initExtraitAnim();
    setTimeout(initDiscountBanner, 300);
    initCollectionPriceFix();
  });
})();
